import {
  UPDATE_QUOTATION,
  SEARCH_CUSTOMER_BY_FISCAL,
  SEARCH_CUSTOMER_BY_VAT,
  CUSTOMER_RECEIVED,
  CUSTOMER_FOUND,
  UPDATE_CUSTOMER_INPUT,
  RESET_CUSTOMER,
  SET_UPDATED,
} from './constants';

export function updateQuotation(params) {
  return {
    type: UPDATE_QUOTATION,
    quotation: params,
  };
}

export function setUpdated(value) {
  return {
    type: SET_UPDATED,
    value,
  };
}

export function searchCustomerByFiscal(fiscalCode, contractualCategory = null,customer=null) {
  return {
    type: SEARCH_CUSTOMER_BY_FISCAL,
    fiscalCode,
    contractualCategory,
    customer
  };
}

export function searchCustomerByVat(vatNumber, contractualCategory = null,customer=null) {
  return {
    type: SEARCH_CUSTOMER_BY_VAT,
    vatNumber,
    contractualCategory,
    customer
  };
}

export function customerLoaded(customer) {
  return {
    type: CUSTOMER_RECEIVED,
    customer,
  };
}

export function customerFound(found) {
  return {
    type: CUSTOMER_FOUND,
    found,
  };
}

export function resetCustomer() {
  return {
    type: RESET_CUSTOMER,
  };
}

export function updateCustomerInput(field, value) {
  return {
    type: UPDATE_CUSTOMER_INPUT,
    field,
    value
  };
}
